const CHANGE_USERINFO_ERROR_COOKIE = '_change_userinfo_error';

export const EnumEditPage = {
    UserInfo: 'userinfo',
    FavoriteClub: 'favorite_club',
    EmailSetting: 'email_setting',
    OneTouchPass: 'otp_path'
};
Object.freeze(EnumEditPage);

export const EnumContactCode = {
    StoreNoticeCode: '02',    // Ｊリーグオンラインストアからのお知らせ
    NoticeCode: '11'          // Ｊリーグまたはクラブチームからのお知らせ
};
Object.freeze(EnumContactCode);

/**
 * @deprecation constant.js を使う
 * @type {{Minimum: string, Normal: string, Full: string}}
 */
export const EnumClientDisplayPattern = {
    Minimum: "00",
    Normal: "01",
    Full: "02"
};
Object.freeze(EnumClientDisplayPattern);

export const mixinJleague = {
    computed: {
        allClubTeams: function(){
            return jleagueClubList.getAllClubTeams();
        },
        /**
         * @deprecation mixinJleagueClient を使う
         */
        jleagueClient: function(){
            return (typeof jleagueClient !== 'undefined')? jleagueClient: {};
        }
    },
    filters: {
        emblemImagePath: function(file){
            return 'https://auth2.jleague.jp/emblem/' + file;
        }
    },
    methods: {
        backToHome: function(){
            location.href = '/home';
        },
        getSpecifiedClubTeams: function(league){
            return jleagueClubList.getSpecifiedClubTeams(league);
        },
        getClubTeamByClubCode: function(code){
            return this.allClubTeams.find(function(clubTeam){
                return clubTeam.clubCode === code;
            });
        },
        getUrlParams: function(url){
            if (!url) return null;

            const regexp = new RegExp(/\?([^?]*)$/);
            const result = regexp.exec(url);

            if (!result || result[1] === '') return null;

            return result[1].split('&').map(function(element){
                return element.split('=');
            }).reduce(function(accumulator, current){
                const key = current[0];
                const value = current[1];

                return {
                    ...accumulator,
                    [key]: value
                }
            }, {});
        },
        getUrlParamByKey: function(url, key){
            const regexp = new RegExp("[?&]" + key + "(=([^&#]*)|&|#|$)");
            const result = regexp.exec(url);

            return (result && result[2])? decodeURIComponent(result[2].replace(/\+/g, " ")): null;
        },
        addUrlParams: function(url, params){
            const u = new URL(url);
            Object.keys(params).forEach(function(key){
                u.searchParams.set(key, params[key]);
            });

            return u.toString();
        },
        emptyStringToNull: function(value){
            return (value !== '')? value: null;
        },
        buildContactCode: function(clubCode, accepts){
            return clubCode + '=' + accepts.sort().join(',');
        },
        async getPlayerMaster(clubCode) {
            try {
                let data;
                const baseURL = 'https://login-api2.jleague.jp';
                const url = `${baseURL}/player_master`;
                const apiKey = 'pm_bYNb9mHjFR9m8KNhEfuh';
                const response = await fetch(`${url}?club_cd=${clubCode}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-api-key': apiKey
                    }
                });
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                } else {
                    data = await response.json();
                    return data.player_master;
                }
            } catch (error) {
                console.error('Error fetching player master:', error);
                throw new Error('選手情報の取得に失敗しました。');
            }
        }
    }
};
const mixinAlertMessage = {
    computed: {
        alertIcon: function(){
            switch (this.alertType) {
                case EnumAlertType.Success:
                    return 'fa-check';
                case EnumAlertType.Info:
                    return 'fa-info-circle';
                case EnumAlertType.Warning:
                    return 'fa-exclamation-circle';
                case EnumAlertType.Error:
                    return 'fa-exclamation-triangle';
                default:
                    return null;
            }
        }
    }
};

/**
 * userinfo の初期値を定義
 * @type {{tel_no_fixed: {default: string}, birthday_ymd: {default: string}, member_last_nm: {default: string}, address_state: {default: string}, address_city: {default: string}, post_cd2: {default: string}, post_cd1: {default: string}, sex_kbn: {default: string}, member_first_nm: {default: string}, address_street: {default: string}, member_last_nm_kana: {default: string}, address_building: {default: string}, member_first_nm_kana: {default: string}, jleague_id: {default: string}}}
 */
export const UserInfoProperties = {
    jleague_id: {
        default: ''
    },
    birthday_ymd: {
        default: ''
    },
    member_last_nm: {
        default: ''
    },
    member_first_nm: {
        default: ''
    },
    member_last_nm_kana: {
        default: ''
    },
    member_first_nm_kana: {
        default: ''
    },
    sex_kbn: {
        default: '0'
    },
    post_cd1: {
        default: ''
    },
    post_cd2: {
        default: ''
    },
    address_state: {
        default: ''
    },
    address_city: {
        default: ''
    },
    address_street: {
        default: ''
    },
    address_building: {
        default: ''
    },
    tel_no_fixed: {
        default: ''
    }
};
Object.freeze(UserInfoProperties);

/**
 * 不足している userinfo プロパティーの初期値をセットする
 * @type {{methods: {assignDeficientProperties: (function(*): *)}}}
 */
export const mixinUserInfoProperties = {
    methods: {
        assignDeficientProperties: function(userInfoPatch){
            Object.keys(UserInfoProperties).forEach(function(key){
                if (!userInfoPatch.hasOwnProperty(key)) {
                    userInfoPatch[key] = UserInfoProperties[key].default;
                }
            });

            return userInfoPatch;
        }
    }
};

/**
 * 会員情報変更画面の入力フィールド用 mixin
 * @type {{computed: {klass: (function(): {error: *})}, props: {validate: {type: ObjectConstructor, required: boolean}}}}
 */
export const mixinUserInfoFieldComponent = {
    props: {
        model: {
            type: String,
            default: ''
        },
        isRequired: {
            type: Boolean,
            default: false
        }
    },
    filters: {
        klass: function(error){
            return { error: error };
        }
    }
};

export const mixinFavoriteClub = {
    computed: {
        favoriteClubs: {
            set: function(value){
                if (typeof value === 'string'){
                  this.userInfoPatch.club_cd = value;
                }else{
                  this.userInfoPatch.club_cd = value.toString();
                }
            },
            get: function(){
                var clubs = [];
                if (typeof this.userInfoPatch.club_cd === 'string'){
                    clubs = this.userInfoPatch.club_cd.split(',');
                }else{
                    clubs = this.userInfoPatch.club_cd;
                }
                return clubs;
            }
        },
        contactCodeToArray: function(){
            const contacts = this.userInfoPatch.contact_cd;

            // `userinfo.contact_cd` が文字列のとき、配列に変換して返す
            return (typeof contacts === 'string')? [contacts]: contacts;
        },
        contactCodes: {
            set: function(values){
                switch (values.length) {
                    case 0:
                        // 0件のときは null で登録する
                        this.userInfoPatch.contact_cd = null;
                        break;
                    case 1:
                        // 1件のときは配列ではなく文字列で登録する
                        this.userInfoPatch.contact_cd = values.toString();
                        break;
                    default:
                        // 配列で登録する
                        this.userInfoPatch.contact_cd = values;
                }
            },
            get: function(){
                return this.userInfoPatch.contact_cd;
            }
        }
    },
    methods: {
        buildContactCode: function(clubCode, accepts){
            return clubCode + '=' + accepts.sort().join(',');
        }
    }
};

export const mixinOneTouchPass = {
    computed: {
        oneTouchPassToArray: function(){
            // `userinfo.otpmember_view` が null のとき、空配列に変換する
            const passes = (this.userInfoPatch.otpmember_view === null)? []: this.userInfoPatch.otpmember_view;

            // `userinfo.otpmember_view` が文字列のとき、配列に変換して返す
            return (typeof passes === 'string')? [passes]: passes;
        },
        oneTouchPassObjects: function(){
            // object のデータが含まれていたら除外する
            const passes = this.oneTouchPassToArray.filter(function(pass){
                return typeof pass === 'string';
            });

            return passes.map(function(pass){
                // `,` と `=` 区切りの文字列をオブジェクトに変換する
                return pass.split(',').map(function(element){
                    return element.split('=');
                }).reduce(function(accumulator, current){
                    const key = current[0];
                    const value = current[1];

                    return {
                        ...accumulator,
                        [key]: value
                    };
                }, {});
            });
        }
    }
};

export const EnumSignupStep = {
    BasicInfo: "BASIC_INFO",
    FavoriteClub: "FAVORITE_CLUB",
    FavoritePlayer: "FAVORITE_PLAYER",
    Confirm: "CONFIRM"
};
Object.freeze(EnumSignupStep);

export const mixinSignup = {
    computed: {
        isBasicInfo: function(){
            return this.step === EnumSignupStep.BasicInfo;
        },
        isFavoriteClub: function(){
            return this.step === EnumSignupStep.FavoriteClub;
        },
        isFavoritePlayer: function(){
            return this.step === EnumSignupStep.FavoritePlayer;
        },
        isConfirm: function(){
            return this.step === EnumSignupStep.Confirm;
        }
    },
    methods: {
        setContactCode: function(){
            const self = this;
            let _contacts = [];

            // お気に入りクラブと、Ｊリーグのメールを受け取るをONにしたとき
            if (this.checkReceiveMail) {
                let codes = [];
                if (this.userinfo.club_cd){
                    codes = this.userinfo.club_cd.split(',').sort();
                }
                codes.push('JL');
                const _filer_codes = codes.filter(code => {
                   return (code !== 'G2' && code !== 'C2');
                });
                _contacts = _filer_codes.map(function(code){
                    const contactCode = (code === 'JL')?
                        [
                            EnumContactCode.StoreNoticeCode,
                            EnumContactCode.NoticeCode
                        ]:
                        [
                            EnumContactCode.NoticeCode
                        ];

                    return self.buildContactCode(code, contactCode);
                });
            }

            switch (_contacts.length) {
                case 0:
                    // 0件のときは null で登録する
                    this.userinfo.contact_cd = null;
                    break;
                case 1:
                    // 1件のときは配列ではなく文字列で登録する
                    this.userinfo.contact_cd = _contacts.toString();
                    break;
                default:
                    // 配列で登録する
                    this.userinfo.contact_cd = _contacts;
                    break;
            }
        }
    }
};
